import { Clock } from 'lucide-react'
import type React from 'react'
import { useMemo } from 'react'
import { formatISTTime } from '../../lib/date-utils'
import { useMarketStore } from '../../services/store'

export const LiveTickerDisplay: React.FC = () => {
    const timestamp = useMarketStore((state) => state.lastUpdated)

    const displayTime = useMemo(() => {
        if (!timestamp) return '--:--:--'
        return formatISTTime(timestamp)
    }, [timestamp])

    return (
        <div className="flex items-center gap-1.5 px-3.5 py-1 bg-emerald-50 dark:bg-emerald-900/30 rounded-full shadow-sm border border-emerald-100 dark:border-emerald-800 shrink-0 group hover:bg-emerald-100 transition-colors">
            <Clock className="w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400 mr-1" />
            
            <div
                className={`w-1.5 h-1.5 rounded-full bg-emerald-500 ${timestamp ? 'animate-pulse' : ''}`}
            />
            <span className="premium-cell-mono font-bold text-emerald-800 dark:text-emerald-100 text-[11px] md:text-[13px] min-w-[60px] text-center tracking-tight">
                {displayTime}
            </span>
        </div>
    )
}
